import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectedRegionIdSelector, selectedRegionIdsSelector, setSelectedRegion } from '../filtersSlice';
import { RegionSelectProps } from '../RegionSelect';

/** хук берет и работает с данными по выбранному региону из `filterSlice` */
export const useSelectedRegion = () => {
  const dispatch = useDispatch();
  const regionId = useSelector(selectedRegionIdSelector);
  const regionIds = useSelector(selectedRegionIdsSelector);

  const onSelectRegion: NonNullable<RegionSelectProps['onSelect']> = React.useCallback((id, ids) => {
    dispatch(setSelectedRegion({ id, ids }));
  }, [dispatch]);
  return {
    regionId,
    regionIds,
    onSelectRegion,
  };
};
